import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import IconButton from '@material-ui/core/IconButton';

class AddButton extends React.Component {

    render() {

        return (
            <Tooltip title={this.props.title}>
                <span>
                    <IconButton color={this.props.color} disabled={this.props.disabled} data-test={this.props.dataTest} size="small" onClick={this.props.onClick}>
                        {this.props.icon}
                    </IconButton>
                </span>
            </Tooltip>
        );
    }
}

AddButton.defaultProps = {
    icon: <AddCircleIcon />,
    disabled: false,
};

AddButton.propTypes = {
    dataTest: PropTypes.string,
    disabled: PropTypes.bool,
    color: PropTypes.string,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func
};

export default AddButton;